export default __webpack_public_path__ + "static/media/save.f79a6ba7.svg";